import React, { ReactElement } from 'react';

import { Typography } from 'components';
import { useSchool } from 'features/school';

const Copyright = (): ReactElement => {
  const { schoolName } = useSchool();

  return (
    <Typography type="type0" color="footerColor">
      {schoolName} - Todos os direitos reservados
    </Typography>
  );
};
export default Copyright;
